// extracted by mini-css-extract-plugin
export default {"header":"Tf218","title":"N4kiG"};